import { render, staticRenderFns } from "./tender.vue?vue&type=template&id=1c2c009f&scoped=true"
import script from "./tender.vue?vue&type=script&lang=js"
export * from "./tender.vue?vue&type=script&lang=js"
import style0 from "./tender.vue?vue&type=style&index=0&id=1c2c009f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2c009f",
  null
  
)

export default component.exports